import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosPut from "../axios/axios-put";
import axiosPost from "../axios/axios-post";
import axiosGet from "../axios/axios-get";
import axiosDelete from "../axios/axios-delete";

export const UsefulTipsAPI = Object.freeze({
  getAll: createAsyncThunk("get/get-stories", async (params) => {
    try {
      const response = await axiosGet.get("/useful-tips", { params });
      return response.data;
    } catch (error) {
      return Promise.reject(error.response?.data || error.message);
    }
  }),

  getOne: createAsyncThunk("get/one-useful-tip", async (id) => {
    try {
      const response = await axiosGet.get(`/useful-tips/${id}`);
      return response.data;
    } catch (error) {
      return Promise.reject(error.response?.data || error.message);
    }
  }),

  create: createAsyncThunk("post/post-useful-tip", async (data) => {
    try {
      const response = await axiosPost.post("/useful-tips", data);
      return response.data;
    } catch (error) {
      return Promise.reject(error.response?.data || error.message);
    }
  }),

  update: createAsyncThunk("put/put-useful-tip", async (data) => {
    try {
      const response = await axiosPut.put(`/useful-tips/${data.id}`, data);
      return response.data;
    } catch (error) {
      return Promise.reject(error.response?.data || error.message);
    }
  }),

  delete: createAsyncThunk("delete/delete-useful-tip", async (id) => {
    try {
      const response = await axiosDelete.delete(`/useful-tips/${id}`);
      return response.data;
    } catch (error) {
      return Promise.reject(error.response?.data || error.message);
    }
  }),
});
